// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1280":"16d91cd0","1311":"0510c735","1761":"6cde383c","3692":"0510c735","3716":"e169704a","5982":"edd77f11","6549":"0510c735","7628":"e169704a","7652":"25838788"}[chunkId] + ".chunk.css";
};